import { DurabilitySFDRSocialEnvironmentalProportion } from '../../../../types';
export var list = [
    DurabilitySFDRSocialEnvironmentalProportion.MIN_TWENTY_FIVE_PERCENT,
    DurabilitySFDRSocialEnvironmentalProportion.MIN_FIFTY_PERCENT,
    DurabilitySFDRSocialEnvironmentalProportion.MIN_SEVENTY_FIVE_PERCENT,
    DurabilitySFDRSocialEnvironmentalProportion.FULL,
];
